export default {
  root: {
    color: "#366b92"
  }
};
